import apiClient from './apiClient';

// Branch service — mirrors r2b-restaurant-mobile-new/src/services/branchService.js.
// Same endpoints, same behaviour.

export const getBranchById = async (branchId) => {
  const response = await apiClient.get(`/branch/${branchId}`);
  return response.data;
};

export const getBranchStats = async (branchId, query = {}) => {
  const response = await apiClient.get(`/branch-stats/${branchId}`, { params: query });
  return response.data;
};

export const getUserBranches = async (query = {}) => {
  const response = await apiClient.get('/restaurant-branches', { params: query });
  return response.data;
};

export const updateBranchStatus = async (branchId, isOperational) => {
  const response = await apiClient.put(`/branch/${branchId}`, { isOperational });
  return response.data;
};

export const updateBranchOffer = async (branchId, offerPercent) => {
  const response = await apiClient.put(`/branch/${branchId}`, { offer: offerPercent });
  return response.data;
};

export const getOperationalHours = async (branchId) => {
  const response = await apiClient.get(`/branch/${branchId}`);
  return response.data?.operationalHours || [];
};

export const updateOperationalHours = async (branchId, hours) => {
  const response = await apiClient.put(`/branch/${branchId}`, { operationalHours: hours });
  return response.data;
};
